import {
  SETTING_ALL,
  SETTING_PUT,
  SETTING_LOADING,
  SETTING_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const settingAll = () => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/setting`,
    );
    if (status === 200) {
      dispatch({ type: SETTING_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: SETTING_ERROR });
    throw new Error(error);
  }
};

export const settingPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: SETTING_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/setting/${id}`,
      payload,
    );
    dispatch({ type: SETTING_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: SETTING_ERROR });
    throw new Error(error);
  }
};
